"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSantanderFinancingTypeToEnum = exports.mapSantanderCustomerTypeToEnum = void 0;
const enums_1 = require("../enums");
const mapSantanderCustomerTypeToEnum = (type) => {
    switch (type) {
        case 'Company':
            return enums_1.CustomerType.BUSINESS;
        case 'Private':
        default:
            return enums_1.CustomerType.PRIVATE;
    }
};
exports.mapSantanderCustomerTypeToEnum = mapSantanderCustomerTypeToEnum;
const mapSantanderFinancingTypeToEnum = (type) => {
    switch (type) {
        case 'Leasing':
            return enums_1.FinancingType.LEASING;
        case 'Loan':
        default:
            return enums_1.FinancingType.LOAN;
    }
};
exports.mapSantanderFinancingTypeToEnum = mapSantanderFinancingTypeToEnum;
//# sourceMappingURL=santander.js.map